import React from "react";
import Gauge from "./Gauge";
import { Numeral } from "react-numeral";
import Image from "../../Tags/Image";

export default function SEO({ data = {} }) {
  const Card = ({ icon, label, value, doller = false }) => (
    <div className="p-6 border border-gray-200 bg-gray-50 rounded-xl flex-1">
      <Image src={icon} className="mb-5 no-invert" />
      <span className="text-[12px] capitalize whitespace-pre mb-2 leading-none block">{label}</span>
      <span className="text-gray-900 font-bold leading-none uppercase text-2xl block">
        {doller ? "$" : ""}

        <Numeral
          className="text-gray-900 font-bold leading-none uppercase "
          value={value}
          format={"0.[0]a"}
        />
      </span>
    </div>
  );

  return (
    <>
      <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4  py-2 px-4">
        <h3 className="text-text-700 my-2 mb-4  text-[16px] font-semibold">Search Engine Performance</h3>
        <div className="flex py-4 space-x-4 mb-2 px-4 justify-evenly border rounded-[14px] overflow-hidden border-input  bg-gray-50 relative mt-4">
          <div className="w-full space-y-3">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                fill="var(--blue-dark-50)"
              />
              <path
                d="M19.1351 23.189L15.3304 16.3805C14.8929 15.5976 14.6742 15.2062 14.711 14.8857C14.7432 14.6061 14.8917 14.353 15.1201 14.1885C15.3819 14 15.8303 14 16.7271 14H18.9619C19.2952 14 19.4619 14 19.6114 14.0481C19.7436 14.0907 19.8656 14.1604 19.9694 14.2528C20.0867 14.3571 20.1713 14.5007 20.3405 14.7879L24.0001 21L27.6597 14.7879C27.8289 14.5007 27.9135 14.3571 28.0308 14.2528C28.1347 14.1604 28.2566 14.0907 28.3889 14.0481C28.5383 14 28.705 14 29.0383 14H31.2731C32.1699 14 32.6183 14 32.8801 14.1885C33.1085 14.353 33.257 14.6061 33.2892 14.8857C33.326 15.2062 33.1073 15.5976 32.6698 16.3805L28.8651 23.189M22.5001 26L24.0001 25V30M22.7501 30H25.2501M28.5963 22.9038C31.1347 25.4422 31.1347 29.5578 28.5963 32.0962C26.0579 34.6346 21.9423 34.6346 19.4039 32.0962C16.8655 29.5578 16.8655 25.4422 19.4039 22.9038C21.9423 20.3654 26.0579 20.3654 28.5963 22.9038Z"
                stroke="var(--blue-dark-500)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div>
              <h4 className="text-sm text-gray-600">Average Organic Rank</h4>
              <h4 className="text-xl text-gray-900 font-bold  mt-2">
                {data?.average_organic_rank ? data?.average_organic_rank : "-"}
              </h4>
            </div>
          </div>
          <div className="w-full space-y-3">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                fill="var(--blue-dark-50)"
              />
              <path
                d="M34 19L26.1314 26.8686C25.7354 27.2646 25.5373 27.4627 25.309 27.5368C25.1082 27.6021 24.8918 27.6021 24.691 27.5368C24.4627 27.4627 24.2646 27.2646 23.8686 26.8686L21.1314 24.1314C20.7354 23.7354 20.5373 23.5373 20.309 23.4632C20.1082 23.3979 19.8918 23.3979 19.691 23.4632C19.4627 23.5373 19.2646 23.7354 18.8686 24.1314L14 29M34 19H27M34 19V26"
                stroke="var(--blue-dark-500)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div>
              <h4 className="text-sm text-gray-600">Gained ranks</h4>
              <h4 className="text-xl text-gray-900 font-bold  mt-2">
                {data?.gained_ranks ? data?.gained_ranks : "-"}
              </h4>
            </div>
          </div>
          <div className="w-full space-y-3">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                fill="var(--blue-dark-50)"
              />
              <path
                d="M34 29L26.1314 21.1314C25.7354 20.7354 25.5373 20.5373 25.309 20.4632C25.1082 20.3979 24.8918 20.3979 24.691 20.4632C24.4627 20.5373 24.2646 20.7354 23.8686 21.1314L21.1314 23.8686C20.7354 24.2646 20.5373 24.4627 20.309 24.5368C20.1082 24.6021 19.8918 24.6021 19.691 24.5368C19.4627 24.4627 19.2646 24.2646 18.8686 23.8686L14 19M34 29H27M34 29V22"
                stroke="var(--blue-dark-500)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div>
              <h4 className="text-sm text-gray-600">Lost ranks</h4>
              <h4 className="text-xl text-gray-900 font-bold mt-2">
                {data?.lost_ranks ? data?.lost_ranks : "-"}
              </h4>
            </div>
          </div>
        </div>

        <div className="flex my-4 justify-between space-x-4 mobile:block mobile:space-x-0 mobile:space-y-4">
          {data?.monthly_organic_value && (
            <Card
              value={data?.monthly_organic_value}
              label="Monthly Organic Value"
              icon={"/images/ext/companyinfo/money-blue.svg"}
            />
          )}
          {data?.monthly_organic_clicks && (
            <Card
              value={data?.monthly_organic_clicks}
              label="Monthly Organic Clicks"
              icon={"/images/ext/companyinfo/click-blue.svg"}
            />
          )}
          {data?.monthly_paid_clicks && (
            <Card
              value={data?.monthly_paid_clicks}
              label="Monthly Paid Clicks"
              icon={"/images/ext/companyinfo/click-blue.svg"}
            />
          )}
        </div>
        {data && data?.organic_competitors && data?.organic_competitors.length > 0 && (
          <div className=" py-4 mb-2 px-4 border rounded-[14px] overflow-hidden border-gray-200 bg-gray-50 relative mt-4">
            <div className="pb-3 ">
              <span className="text-[16px] text-text-700 mr-3 font-bold">Organic Competitors</span>
            </div>
            <div className="">
              {data && data?.organic_competitors && data?.organic_competitors.length > 0
                ? data?.organic_competitors.map((item) => (
                    <span className="inline-block text-[12px] bg-purple-50 text-purple-700 border border-purple-200 px-3 py-1 rounded-[8px] mr-3 mb-3">
                      {item}
                    </span>
                  ))
                : "-"}
            </div>
          </div>
        )}
        {data && data?.paid_competitors && data?.paid_competitors.length > 0 && (
          <div className=" py-4 mb-2 px-4 border rounded-[14px] overflow-hidden border-gray-200 bg-gray-50 relative mt-4">
            <div className="pb-3 ">
              <span className="text-[16px] text-text-700 mr-3 font-bold">Paid Competitors</span>
            </div>
            <div className="">
              {data && data?.paid_competitors && data?.paid_competitors.length > 0
                ? data?.paid_competitors.map((item) => (
                    <span className="inline-block text-[12px] bg-purple-50 text-purple-700 border border-purple-200 px-3 py-1 rounded-[8px] mr-3 mb-3">
                      {item}
                    </span>
                  ))
                : "-"}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
